/**
 * Small pure derivations shared by listing/dashboard views. Extracted so the
 * logic is unit-testable without rendering server components.
 */

/** Cut size and percent when a listing sits below its original ask; null otherwise. */
export function priceCutSummary(
  originalListPrice: number | undefined,
  price: number
): { cut: number; pct: number } | null {
  const original = originalListPrice ?? 0;
  if (!(original > price && price > 0)) return null;
  const cut = original - price;
  return { cut, pct: Math.round((cut * 100) / original) };
}

// `statusPhrase` lived here and is gone. It collapsed `active_contingent` into
// "sale pending", which is wrong — a contingent listing is still taking backup
// offers, so it stays tourable. `lib/availability` draws that line and is the one
// vocabulary for availability across the app. (W16 R152)

export interface ChecklistItem {
  done: boolean;
  label: string;
  hint: string;
  href: string;
}

/** First-time-buyer setup checklist derived from what the user has done. */
export function buyerChecklist(counts: {
  searches: number;
  favorites: number;
  destinations: number;
  tours: number;
}): ChecklistItem[] {
  return [
    {
      done: counts.searches > 0,
      label: 'Save a search',
      hint: 'Get notified when matching homes hit the market',
      href: '/homes',
    },
    {
      done: counts.favorites > 0,
      label: 'Favorite a home',
      hint: 'Build a shortlist you can compare',
      href: '/homes',
    },
    {
      done: counts.destinations > 0,
      label: 'Add a commute destination',
      hint: 'See drive times from every listing',
      href: '/settings/destinations',
    },
    {
      done: counts.tours > 0,
      label: 'Book a free tour',
      hint: 'See a home in person with zero obligation',
      href: '/open-houses',
    },
  ];
}
